module.exports = __webpack_public_path__ + "img/blockAB51.5270b421.svg";